module.exports = __webpack_public_path__ + "static/img/4322_phase_function_Paper_Points.d8c5f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4322_phase_function_Paper_Points.png
// module id = vDoq
// module chunks = 0